import { ActionType, createAsyncAction } from 'typesafe-actions';
import { FetchAction, SuccessFetchActionPayload, DefaultErrorPayload } from '../dataFetching/generators';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { addNotification } from '../notifications/actions';
import { DisplayType } from '../notifications/types';

export const backInStockReminderAction = createAsyncAction(
    '@BACK_IN_STOCK_REMINDER/SET_START',
    '@BACK_IN_STOCK_REMINDER/SET_SUCCESS',
    '@BACK_IN_STOCK_REMINDER/SET_FAILED'
)<FetchAction, SuccessFetchActionPayload<{}>, DefaultErrorPayload>();

export type BackInStockReminderActionType = ActionType<typeof backInStockReminderAction>;

export interface Notifications {
    success: string;
    failure: string;
}

const setBackInStockReminder = (
    simpleSku: string,
    email: string,
    notifications: Notifications
): DataFetchingThunkAction => async (dispatch, _, { apiService, logger }) => {
    const identifier = 'BACK_IN_STOCK_REMINDER';
    dispatch(backInStockReminderAction.request({ identifier }));
    try {
        await apiService.shopApi.setBackInStockReminder(simpleSku, email);
        dispatch(backInStockReminderAction.success({ data: {}, identifier }));
        dispatch(addNotification(notifications.success));
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'setBackInStockReminder');
        dispatch(backInStockReminderAction.failure({ error: err, identifier }));
        dispatch(addNotification(notifications.failure, null, DisplayType.error));
    }
};

export default setBackInStockReminder;
